var loading: boolean = true;

export const showLoader = () => {
    if(loading)return;
    loading = true;
    document.body.style.overflow = 'hidden';
    document.getElementById('global-loader').style.display = 'block';
}

export const hideLoader = () => {
    if(!loading) return;
    loading = false;
    document.body.style.overflow = 'auto';
    document.getElementById('global-loader').style.display = 'none';
}

export const getLoadingStatus: boolean | any = () => {
    return loading;
}